module.exports = __webpack_public_path__ + "static/media/5ed7b11672f4e5e57a748793.61911265.png";